import React from "react";
import { Card } from "@/components/ui/card";
import { PARTNERS } from "@/lib/content";
import { Handshake } from "lucide-react";

export default function PartnersPage() {
  return (
    <div data-testid="partners-page">
      <section className="bg-primary text-white py-20 md:py-24 text-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="text-xs uppercase tracking-widest text-accent font-semibold">Partners</span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mt-3 mb-4" style={{ fontFamily: "Outfit" }}>
            Stronger together
          </h1>
          <p className="text-white/80 max-w-2xl mx-auto">
            We collaborate with leading institutions to drive farmer prosperity and rural transformation.
          </p>
        </div>
      </section>

      <section className="py-20 md:py-24">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-8">
          {PARTNERS.map((p) => (
            <Card key={p.name} className="p-8 rounded-2xl border-border bg-white hover:shadow-lg transition-shadow" data-testid={`partner-detail-${p.name.toLowerCase()}`}>
              <div className="h-28 flex items-center justify-center mb-6 bg-secondary/40 rounded-2xl">
                <img src={p.image} alt={p.name} className="max-h-24 max-w-[80%] object-contain" />
              </div>
              <h3 className="text-2xl font-bold mb-2" style={{ fontFamily: "Outfit" }}>{p.name}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{p.description}</p>
            </Card>
          ))}
        </div>

        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center mt-16">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-secondary text-primary mb-5">
            <Handshake className="w-8 h-8" />
          </div>
          <h2 className="text-2xl md:text-3xl font-bold mb-3" style={{ fontFamily: "Outfit" }}>
            Become a partner
          </h2>
          <p className="text-muted-foreground">
            Are you an organization, institution or buyer who shares our vision of farmer prosperity? Reach out to us
            to explore meaningful collaborations.
          </p>
        </div>
      </section>
    </div>
  );
}
